import { Routes } from '@angular/router';
import { roleGuard } from './core/guards/role.guard';
import { Role } from './core/models/role.enum';
import { UnauthorizedComponent } from './Modules/Motor_leasing/unauthorized/unauthorized.component';
import { authGuard } from './core/guards/auth.guard';
import { MotorSmeDasboardComponent } from './Modules/Motor_sme/motor-sme-dasboard/motor-sme-dasboard.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'lessee-dashboard',
    pathMatch: 'full'
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: 'lessee-dashboard',
    loadComponent: () =>
      import('./auth/lesseeDashboard/lesseeDashboard.component').then(m => m.LesseeDashboardComponent)
  },
  {
    path: 'admin-login',
    loadComponent: () => import('./auth/admin-login/admin-login.component').then(m => m.AdminLoginComponent)
  },
  {
    path: 'admin',
    canActivate: [roleGuard, authGuard],
    data: {
      expectedRole: [Role.TtAdmin, Role.TtProxyAdmin, Role.TtAgent],
    },
    loadChildren: () =>
      import('./Modules/Motor_leasing/admin/dasboard/dasboard.module').then(m => m.DasboardModule)
  },
  {
    path: 'lessee',
    loadChildren: () =>
      import('./Modules/Motor_leasing/lessee/home/home.module').then(
        m => m.HomeModule
      ),
  },
  {
    path: 'lessor-login',
    loadComponent: () =>
      import('./auth/lessor-login/lessor-login.component').then(
        m => m.LessorLoginComponent
      ),
  },
  {
    path: 'lessor',
    canActivate: [roleGuard, authGuard],
    data: {
      expectedRole: [Role.LessorAdmin, Role.LessorProxyAdmin, Role.LessorAgent],
    },
    loadChildren: () => import('./Modules/Motor_leasing/lessor/lessor-dashboard/lessor-dashboard.module').then(m => m.LessorDashboardModule),
  },
    {
    path: 'motor-sme',
    loadComponent: () => import('./Modules/Motor_sme/motor-sme-dasboard/motor-sme-dasboard.component').then(m => m.MotorSmeDasboardComponent)
  },
  {
    path: 'medical-sme',
    loadComponent: () => import('./Modules/Medical_sme/medical-sme-dashboard/medical-sme-dashboard.component').then(m => m.MedicalSmeDashboardComponent)
  },


  { path: '**', redirectTo: '/lessee-dashboard' }

];
